import styled from 'styled-components'

export const TravelSegmentContainer = styled.div<{ $isHidden: boolean }>`
	display: ${props => (props.$isHidden ? 'none' : 'flex')};
	align-items: stretch;
`

export const TravelDotColumn = styled.div`
	width: 24px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
`

export const TravelDotLine = styled.div`
	flex: 1;
	width: 0;
	border-left: 2px dashed #d4a574;
	min-height: 8px;
`

export const TravelDotLineTop = styled.div`
	flex: 1;
	width: 0;
	border-left: 2px dashed #d4a574;
	min-height: 8px;
`

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	background: #fed7aa;
	border-radius: 50%;
	flex-shrink: 0;
	position: relative;
	z-index: 1;

	svg {
		width: 14px;
		height: 14px;
		fill: #9a3412;
	}
`

export const SegmentContent = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin-left: 10px;
	padding: 0.3rem 0.5rem 0.3rem 12px;
	cursor: pointer;
	border-radius: 6px;
	transition: background 0.15s ease;

	&:hover {
		background: rgba(254, 243, 199, 0.7);
	}
`

export const InfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.35rem;
	font-size: 0.75rem;
	font-weight: 500;
	color: #78350f;
`

export const Bullet = styled.span`
	color: #92400e;
	font-weight: 600;
`

export const DirectionsText = styled.span`
	color: #ea580c;
	font-weight: 600;
	font-size: 0.75rem;
	white-space: nowrap;
	margin-left: 0.15rem;
`
